<template>
  <v-btn
    :data-cy="dataCy"
    icon="mdi-chevron-right"
    size="small"
    variant="flat"
    class="table-expand-btn"
    :class="{ 'table-expand-btn--active': isExpanded }"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TableExpandButton',
  inheritAttrs: false,
  props: {
    isExpanded: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      required: false
    }
  }
})
</script>

<style lang="scss" scoped>
.table-expand-btn {
  font-size: 1rem;
  color: var(--tsi-color--dark-56);
  transform: rotate(0deg);

  &--active {
    transform: rotate(90deg);
  }
}
</style>
